import { QUEUED_TASK_TYPE_COUNTS } from "./constants";
import { Data, TASK_OVERVIEW_STATUSES, TIMEFRAMES } from "./types";

export const initialData: Data = {
    [QUEUED_TASK_TYPE_COUNTS]: [],
    [TIMEFRAMES.TaskCount7Days]: {
        [TASK_OVERVIEW_STATUSES.Completed]: [],
        [TASK_OVERVIEW_STATUSES.CompletedWithErrors]: [],
        [TASK_OVERVIEW_STATUSES.Failed]: []
    },
    [TIMEFRAMES.TaskCount30Days]: {
        [TASK_OVERVIEW_STATUSES.Completed]: [],
        [TASK_OVERVIEW_STATUSES.CompletedWithErrors]: [],
        [TASK_OVERVIEW_STATUSES.Failed]: []
    },
    [TIMEFRAMES.TaskCount90Days]: {
        [TASK_OVERVIEW_STATUSES.Completed]: [],
        [TASK_OVERVIEW_STATUSES.CompletedWithErrors]: [],
        [TASK_OVERVIEW_STATUSES.Failed]: []
    }
};
